import { websiteHttpClient } from 'src/editor/api/http-clients/website-http-client'
import {
  WebsiteThemeInterface,
  WebsiteThemesResponseInterface,
} from 'src/shared/types/website-settings-types'

export const getWebsiteThemes = () =>
  websiteHttpClient<WebsiteThemesResponseInterface>('themes', 'GET')

export const getWebsiteThemeById = (id: number) =>
  websiteHttpClient<WebsiteThemeInterface>(`themes/${id}`, 'GET')

export const deleteWebsiteThemeById = (id: number) =>
  websiteHttpClient(`themes/${id}`, 'DELETE')
